import { IState } from '..';
import { ISalesRep, ISalesRepCallGoal } from './salesRepInterfaces';

export function getSalesReps(state: IState): ISalesRep[] {
  return Object.values(state.salesRep.salesReps);
}

export function getCallGoals(state: IState, request: { sid: string; fiscalYear: string }): ISalesRepCallGoal[] {
  return state.salesRep.callGoals.filter(x => x.fiscalYear === request.fiscalYear && x.sid === request.sid);
}
